import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    loginResponse: null,
    userObj: null,
    nearestGame: null
  },
  getters: {
    LOGIN_RESPONSE: state => state.loginResponse,
    USER_OBJ: state =>
      state.userObj || JSON.parse(localStorage.getItem('user')),
    IS_ADMIN: state =>
      state.userObj
        ? state.userObj.role === 'super_admin'
        : JSON.parse(localStorage.getItem('user')).role === 'super_admin',
    NEAREST_GAME: state =>
      state.nearestGame || JSON.parse(localStorage.getItem('nearest_game'))
  },
  mutations: {
    SET_LOGIN_RESPONSE: (state, payload) => {
      state.loginResponse = payload
    },
    SET_USER: (state, payload) => {
      state.userObj = payload
      localStorage.setItem('user', JSON.stringify(payload))
    },
    SET_NEAREST_GAME: (state, payload) => {
      state.nearestGame = payload
      localStorage.setItem('nearest_game', JSON.stringify(payload))
    }
  },
  actions: {
    LOGIN_USER: async (context, payload) => {
      try {
        const response = await Axios.post('/auth', payload)
        const userObj = response.data.data.user
        const tokenObj = response.data.data.token
        const nearestGame = response.data.data.nearestGame

        localStorage.setItem('access_token', tokenObj)

        context.commit('SET_LOGIN_RESPONSE', response.data)
        context.commit('SET_USER', userObj)
        context.commit('SET_NEAREST_GAME', nearestGame)
      } catch (error) {
        context.commit('SET_LOGIN_RESPONSE', error.response.data)
      }
    },
    FETCH_FIRST_GAME_OF_ROUND: async context => {
      try {
        const response = await Axios.get('/football/first-round')
        const nearestGame = response.data.data.firstGameOfRound

        context.commit('SET_NEAREST_GAME', nearestGame)
      } catch (error) {
        context.commit('SET_LOGIN_RESPONSE', error.response.data)
      }
    }
  }
}
